import React from 'react';
import { ProgressBar, Step } from 'react-step-progress-bar';
import 'react-step-progress-bar/styles.css';

export const ProgressBaar = ({ percent, title, color }: any) => {
    return (
        <div className={color ? 'progressbar-01 progressbar-01-profile' : 'progressbar-01'}>
            <div className={color ? 'c-container-01 active' : 'c-container-01'}>
                {!color && <span className="c-container-02">{title}</span>}
                <ProgressBar filledBackground={color ? '#000000' : '#00a3ff'} unfilledBackground="#fafafa" percent={percent}>
                    <Step transition="scale">{({ accomplished, index }) => <div className=""></div>}</Step>
                    <Step transition="scale">
                        {({ accomplished, index }) => <div className={`transitionStep ${accomplished ? 'accomplished' : null}`}>{index + 1}</div>}
                    </Step>
                    <Step transition="scale">
                        {({ accomplished, index }) => <div className={`transitionStep ${accomplished ? 'accomplished' : null}`}>{index + 1}</div>}
                    </Step>
                    <Step transition="scale">
                        {({ accomplished, index }) => <div className={`transitionStep ${accomplished ? 'accomplished' : null}`}>{index + 1}</div>}
                    </Step>
                    <Step transition="scale">
                        {({ accomplished, index }) => <div className={`transitionStep ${accomplished ? 'accomplished' : null}`}>{index + 1}</div>}
                    </Step>
                    <Step transition="scale">
                        {({ accomplished, index }) => <div className={`transitionStep ${accomplished ? 'accomplished' : null}`}>{index + 1}</div>}
                    </Step>
                    <Step transition="scale">
                        {({ accomplished, index }) => <div className={`transitionStep ${accomplished ? 'accomplished' : null}`}>{index + 1}</div>}
                    </Step>
                    <Step transition="scale">{({ accomplished, index }) => <div className=""></div>}</Step>
                </ProgressBar>
                {color && <span className="c-item">%{percent}</span>}
            </div>
            {color && <span className="c-container-03">{title}</span>}
        </div>
    );
};

export default ProgressBaar;
